export function checkNativeHLSSupport() {
	let videoEl = document.createElement('video');
	return (
		typeof videoEl.canPlayType === 'function'
			&& Boolean(videoEl.canPlayType('application/vnd.apple.mpegurl'))
	);
}

export function checkMasterPlaylist(playlist) {
	return playlist.indexOf('#EXT-X-STREAM-INF') !== -1;
}

export function getMediaLevels(playlist) {
	let playlistLines = playlist.split('\n');
	let mediaLevels = [];
	for (let index = 0; index < playlistLines.length; index++) {
		let line = playlistLines[index];
		if (line.indexOf('#EXT-X-STREAM-INF') !== 0) continue;
		let nextLine = playlistLines[index + 1];
		let attrs = parseAttrs(line);
		const { resolutionWidth, resolutionHeight } = /(?<resolutionWidth>\d+)\w(?<resolutionHeight>\d+)/.exec(attrs['RESOLUTION']).groups;
		mediaLevels.push({ // такой формат необходим для класса Quality из videojs-quality-switcher/src/quality.js
			attrs,
			url: [nextLine],
			bandwidth: Number(attrs['BANDWIDTH']),
			width: Number(resolutionWidth),
			height: Number(resolutionHeight)
		});
		index += 1; // т.к. следующая после #EXT-X-STREAM-INF строка всегда с урлом который выше уже записан в поле url
	}
	return mediaLevels;
}

function parseAttrs(infoString) {
	// infoString === '#EXT-X-STREAM-INF:PROGRAM-ID=1,BANDWIDTH=528000,RESOLUTION=428x240,CODECS="mp4a.40.2,avc1.77.31"'
	let isSelectName = true;
	let attrName = '';
	let attrs = {};
	let startIndex = infoString.indexOf(':') + 1; // Начинаем после #EXT-X-STREAM-INF:

	for (let loopIndex = startIndex; loopIndex <= infoString.length; loopIndex++) {
		if (isSelectName) {
			attrName = infoString.slice(
				loopIndex,
				infoString.indexOf('=', loopIndex)
			);
			loopIndex += attrName.length;
		} else {
			let isValueInQuotes = infoString[loopIndex] === '"';
			let attrValue = isValueInQuotes
				? getValueInQuotes(infoString, loopIndex)
				: getNumericValue(infoString, loopIndex);
			attrs[attrName] = attrValue;
			loopIndex += attrValue.length;
			if (isValueInQuotes) {
				loopIndex += 2; // Корректирует индекс чтобы он указывал на значение после знака закрывающей кавычки и знака запятой
			}
		}
		isSelectName = !isSelectName;
	}

	return attrs; // {"PROGRAM-ID": "1", "BANDWIDTH": "528000", "RESOLUTION": "428x240", "CODECS": "mp4a.40.2,avc1.77.31"}
}

function getValueInQuotes(string, startPosition) {
	let adjustedStartPosition = startPosition + 1; // Чтобы взять значение после открывающей кавычки
	let finishPosition = string.indexOf('"', adjustedStartPosition);
	return string.slice(adjustedStartPosition, finishPosition);
}

function getNumericValue(string, startPosition) {
	let finishPosition = string.indexOf(',', startPosition);
	if (finishPosition === -1) {
		finishPosition = undefined; // Нужно чтобы slice выбрал до конца строки
	}
	return string.slice(startPosition, finishPosition);
}

export function skipFirst(fn) {
	let isSkip = true;
	return (...args) => {
		if (isSkip) {
			isSkip = false;
			return;
		}
		fn(...args);
	};
}
